import { render } from "./TermsForm.vue?vue&type=template&id=8f25d956&scoped=true"
import script from "./TermsForm.vue?vue&type=script&lang=js"
export * from "./TermsForm.vue?vue&type=script&lang=js"

import "./TermsForm.vue?vue&type=style&index=0&id=8f25d956&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f25d956"]])

export default __exports__